"use client";

import { Footer } from "flowbite-react";
import Logo from "./Logo";

export function FooterComponent() {
  return (
    <Footer container>
      <div className="w-full text-center">
        <div className="w-full justify-between sm:flex sm:items-center sm:justify-between">
          {/* <Footer.Brand> */}
          <div className="inline">
            <Logo className="h-6 sm:h-9" />
          </div>
          {/* </Footer.Brand> */}
          <Footer.LinkGroup>
            <Footer.Link href="#">About</Footer.Link>
            <Footer.Link href="#">Privacy Policy</Footer.Link>
            <Footer.Link href="#">Licensing</Footer.Link>
            <Footer.Link href="#">Contact</Footer.Link>
          </Footer.LinkGroup>
        </div>
        <Footer.Divider />
        <Footer.Copyright href="#" by="TruId™" year={2024} />
      </div>
    </Footer>
  );
}
